import type { ReactNode } from 'react';
import type { Options } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';
import { BLOCKS } from '@contentful/rich-text-types';
import type { Writable } from 'type-fest';
import { renderRichTextContent, makeContentfulRichTextRendererOptions } from '@/cms/richTextContentHelpers';
import type { MakeContentfulRichTextRendererOptions } from '@/cms/richTextContentHelpers';

export function renderRichTextHeading(
  content: Document,
  placeholders?: MakeContentfulRichTextRendererOptions['placeholder']
): ReactNode {
  const options: Writable<MakeContentfulRichTextRendererOptions> = {
    renderNode: Object.values(BLOCKS).reduce(
      (acc, current) => {
        acc[current] = (_text, children) => children;
        return acc;
      },
      {} as Required<Options>['renderNode']
    ),
  };

  if (placeholders) {
    options.placeholder = placeholders;
  }

  const contentText = renderRichTextContent(content, makeContentfulRichTextRendererOptions(options));

  return contentText;
}
